import * as ng from 'angular';
import uiRouter from '@uirouter/angularjs';
import { RenewSubscriptionSummaryComponent } from './renew-subscription-summary';

// @ngInject
let stateConfig = ($stateProvider: ng.ui.IStateProvider) => {

    $stateProvider
        .state('unsubscription.renew-subscription-summary', {
            url: '/renew-subscription-summary',
            data: {
                authorisationLevel: 1,
                pageTitle: 'Subscription Expiration'
            },
            'views': {
                'multiContentUnsubscription': {
                    template: '<renew-subscription-summary flex="100"></renew-subscription-summary>'
                }
            }
        });
};

stateConfig.$inject = ['$stateProvider'];

export const RenewSubscriptionSummaryModule: string = ng
    .module('renew-subscription-summary', [
        'ui.bootstrap',
        uiRouter
    ])
    .component('renewSubscriptionSummary', RenewSubscriptionSummaryComponent)
    .config(stateConfig)
    .name;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/unsubscription/renew-subscription-summary/renew-subscription-summary.module.ts